import React from 'react';

import './index.scss';

//material-ui
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

//custom components
import CustomButton from '../../../../components/basic/CustomButton';

//api
import {api} from '../../../../functions/api'

//other libraries
import { inject, observer } from 'mobx-react';
import Dropzone from 'react-dropzone'

@inject('internal')
@inject('translate')
@observer
export default class PriceImportProducts extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            uploading: false,
            file: null,
            extension: null,
            response: null
        }
    }

    handleDrop = (files) => {
        if(files[0] !== undefined) {
            let fileNameArr = files[0].name.split('.');

            let extension = fileNameArr[fileNameArr.length - 1]
            if(extension === "xls" || extension === "xlsx") {
                this.setState({
                    file: files[0],
                    extension: extension,
                })
            }
        }
        else {
            this.props.internal.setSnackbar(this.props.translate.i18n.GLOBAL.ALERTS.FORMAT_IS_NOT_VALID, true)
        }
        
    }

    handleImport = async() => {
        this.setState({uploading: true})
        if(this.state.file === null) {
            this.setState({uploading: false})
            this.props.internal.setSnackbar(this.props.translate.i18n.GLOBAL.ALERTS.EMPTY_FILE, true)
            return
        }
        let upload_data = await api({
            method: 'post',
            url: 'products/price-import',
            formData: true,
            formDataDoc: true,
            authorization: this.props.internal.user.access_token,
            params: {
                file: this.state.file
            }
        })

        if(upload_data.success === true) {
            
            if(upload_data.data.data) {
                this.setState({response: upload_data.data.message})
            }
            else {
                this.props.onClose(true)
            }

            this.setState({uploading: false})
        }
        else{
            this.props.internal.setSnackbar(upload_data.data.message, true)
            this.setState({uploading: false})
        }
    }

    render() {
        return (
            <Dialog
                open={this.props.open}
                onClose={this.props.onClose}
                
            >
                <DialogTitle className={'title'}>{this.props.title}</DialogTitle>
                <DialogContent className={`import-products-dialog` }>
                {this.state.response !== null ?
                <div className={'import-results'}>
                    <p>{this.state.response}</p>
                </div>
                :
                null
                }
                
                {this.state.response === null?
                <Dropzone
                    onDrop={files => this.handleDrop(files)}
                    // disableClick
                    multiple={false}
                    accept={[".xlsx", ".xls"]}
                    >
                    {({getRootProps, getInputProps, open}) => (
                        <div {...getRootProps()} className={`dropzone ${this.state.file !== null ? "dropped":""}`}>
                        <input {...getInputProps()} />
                            {this.state.file !== null && this.state.file.name?
                                <p>{this.state.file.name}</p>
                                :
                                <p>{this.props.translate.i18n.MODULES.CLIENTS.IMPORT_PLACE}</p>
                            }
                            

                            {/* <button type="button" onClick={() => open()}>
                            {this.props.translate.i18n.MODULES.CLIENTS.IMPORT_CLIENTS_BUTTON}
                            </button> */}
                        </div>
                    )}
                    </Dropzone>
                    :
                    null
                }
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.props.onClose} className={'gray-text'}>
                    {this.props.translate.i18n.GLOBAL.BUTTONS.CANCEL}
                    </Button>
                    
                    <CustomButton
                        justText
                        progressBar={this.state.uploading}
                        onClick={this.handleImport}
                        mystyle={'btn-white-bg'}
                        title={this.props.translate.i18n.GLOBAL.BUTTONS.IMPORT}
                    />
                </DialogActions>
            </Dialog>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/products/list/priceImport/index.js